import React, { Component } from 'react';
import qs from 'querystringify';

import { Explanation } from './components/Explanation/index';
import { CompanyInfo } from './components/CompanyInfo/index';
import { ExternalProviders } from './components/ExternalProviders/index';
import { ContactInfo } from './components/ContactInfo/index';
import { Button } from '../../components/Button/index';
import {
  getLegalForms, getNumberOfEmployees, getIndustries, getModules, getCompanies, createCompany,
  updateCompany, createAssessment, getCookieCompanyId, setCookieCompanyId
} from '../../services/index';

import { Trans, i18nMark, withI18n } from 'lingui-react';
import validate from 'validate.js';
import { v4 as uuidv4 } from 'uuid';
import ReactLoading from 'react-loading';

import closeIcon from '../../assets/images/closeIcon.svg';
import './company.css';

class Company extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companyInfo: {
        _id: '',
        companyName: '',
        industry: '',
        legalForm: '',
        numberOfEmployees: '',
        address: '',
        headquarter: '',
        branches: ''
      },
      externalITProviders: [],
      contactInfo: {
        executiveBoard: {
          firstName: '',
          lastName: '',
          phoneNumber: '',
          email: ''
        },
        dataProtectionOfficer: {
          firstName: '',
          lastName: '',
          phoneNumber: '',
          email: ''
        },
        informationSecurityOfficer: {
          firstName: '',
          lastName: '',
          phoneNumber: '',
          email: ''
        },
        itResponsible: {
          firstName: '',
          lastName: '',
          phoneNumber: '',
          email: ''
        }
      },
      hasError: false,
      industries: [],
      modules: [],
      validationMessages: {},
      formSubmitting: false,
      loading: false
    };
  }

  componentDidMount() {
    document.title = this.props.i18n._(i18nMark('Security Selfie'));
    const additionalCompany = qs.parse(this.props.location.search).new !== undefined;
    this.loadInitialData(additionalCompany);
  }

  // Load initial data
  loadInitialData = (additionalCompany) => {
    getModules().then(modules => {
      getIndustries().then(industries => {
        this.setState({ industries: industries, modules: modules, loading: true }, () => {
          const cookieCompanyId = getCookieCompanyId(this.props.cookies);
          getCompanies().then(companies => {
            let selectedCompany = companies.find(c => c._id === cookieCompanyId);
            if (!selectedCompany && companies.length > 0) {
              selectedCompany = companies[0]; // no companyId specified => select first company
            }
            if (!additionalCompany && selectedCompany) {
              const company = selectedCompany;
              const emptyContactInfo = {
                firstName: '',
                lastName: '',
                phoneNumber: '',
                email: ''
              };
              const externalITProviders = company.externalITProviders || [];
              this.setState({
                companyInfo: Object.assign({}, this.state.companyInfo, {
                  _id: company._id || '',
                  companyName: company.companyName || '',
                  industry: company.industry || '',
                  legalForm: company.legalForm || '',
                  numberOfEmployees: company.numberOfEmployees || '',
                  address: company.address || '',
                  headquarter: company.headquarter || '',
                  branches: company.branches || ''
                }),
                externalITProviders: [...this.state.externalITProviders, ...externalITProviders],
                contactInfo: Object.assign({}, this.state.contactInfo, {
                  executiveBoard: company.executiveBoard || emptyContactInfo,
                  dataProtectionOfficer: company.dataProtectionOfficer || emptyContactInfo,
                  informationSecurityOfficer: company.informationSecurityOfficer || emptyContactInfo,
                  itResponsible: company.itResponsible || emptyContactInfo
                })
              })
            }
            this.setState({ loading: false });
          })
        });
      }).catch(error => {
        this.setState({ loading: false });
        console.log('Error: ', error);
      })
    }).catch(error => {
      this.setState({ loading: false });
      console.log('Error: ', error);
    })
  }

  // CompanyInfo 
  selectIndustry = e => {
    this.setState({ companyInfo: Object.assign({}, this.state.companyInfo, { industry: e.target.value }) }, this.updateFormValidation)
  }

  selectLegalForm = e => {
    this.setState({ companyInfo: Object.assign({}, this.state.companyInfo, { legalForm: e.target.value }) }, this.updateFormValidation)
  }

  selectNumberOfEmployees = e => {
    this.setState({ companyInfo: Object.assign({}, this.state.companyInfo, { numberOfEmployees: e.target.value }) }, this.updateFormValidation)
  }

  onCompanyInfoInputChange = e => {
    const value = e.target.value;
    switch (e.target.name) {
      case 'companyName':
        this.setState({ companyInfo: Object.assign({}, this.state.companyInfo, { companyName: value }) }, this.updateFormValidation)
        break;
      case 'address':
        this.setState({ companyInfo: Object.assign({}, this.state.companyInfo, { address: value }) })
        break
      case 'headquarter':
        this.setState({ companyInfo: Object.assign({}, this.state.companyInfo, { headquarter: value }) })
        break
      case 'branches':
        this.setState({ companyInfo: Object.assign({}, this.state.companyInfo, { branches: value }) })
        break
      default:
        break
    }
  }
  // CompanyInfo

  // External Providers
  onClickAddExternalProvider = () => {
    const newExternalProvider = {
      _id: uuidv4(),
      companyName: '',
      firstName: '',
      lastName: '',
      phoneNumber: '',
      email: ''
    };
    this.setState({ externalITProviders: [...this.state.externalITProviders, newExternalProvider] });
  }

  onClickRemoveExternalProvider = (e) => {
    const externalITProviders = this.state.externalITProviders.filter(ep => ep._id !== e.target.id);
    this.setState({ externalITProviders: externalITProviders });
  }

  onExternalProvidersInputChange = e => {
    const value = e.target.value;
    const inputId = e.target.name.split('_')[0];
    const inputName = e.target.name.split('_')[1];
    const externalITProviders = this.updatexternalITProvidersChange(inputId, inputName, value, this.state.externalITProviders);
    this.setState({ externalITProviders: externalITProviders }, this.updateFormValidation);
  }

  updatexternalITProvidersChange = (id, field, value, externalITProviders) => {
    let newExternalProviders = externalITProviders.map(ep => {
      if (ep._id === id)
        ep[field] = value;
      return ep;
    });
    return newExternalProviders;
  }
  // External Providers

  // ContactInfo
  selectContactPerson = (e) => {
    let contactInfo = {};
    const value = e.target.value;
    switch (e.target.name) {
      case 'dataProtectionOfficer':
        contactInfo = this.state.contactInfo;
        contactInfo.dataProtectionOfficer['assigned'] = value === 'yes';
        this.setState({ contactInfo: Object.assign(contactInfo, { hasDataProtectionOfficer: value }) }, this.updateFormValidation)
        break;
      case 'informationSecurityOfficer':
        contactInfo = this.state.contactInfo;
        contactInfo.informationSecurityOfficer['assigned'] = value === 'yes';
        this.setState({ contactInfo: Object.assign(contactInfo, { hasInformationSecurityOfficer: value }) }, this.updateFormValidation)
        break
      case 'itResponsible':
        contactInfo = this.state.contactInfo;
        contactInfo.itResponsible['assigned'] = value === 'yes';
        this.setState({ contactInfo: Object.assign(contactInfo, { hasItResponsible: value }) }, this.updateFormValidation)
        break
      default:
        break
    }
  }

  onContactInfoInputChange = e => {
    if (e.target.name.indexOf('executiveBoard') > -1) {
      this.updateContactInfoPersonChange(e, 'executiveBoard');
    }
    if (e.target.name.indexOf('dataProtectionOfficer') > -1) {
      this.updateContactInfoPersonChange(e, 'dataProtectionOfficer');
    }
    if (e.target.name.indexOf('informationSecurityOfficer') > -1) {
      this.updateContactInfoPersonChange(e, 'informationSecurityOfficer');
    }
    if (e.target.name.indexOf('itResponsible') > -1) {
      this.updateContactInfoPersonChange(e, 'itResponsible');
    }
  }

  updateContactInfoPersonChange = (e, contactInfoPerson) => {
    let contactInfoMember = this.state.contactInfo[contactInfoPerson] ? this.state.contactInfo[contactInfoPerson] : {};
    const value = e.target.value;
    switch (e.target.name) {
      case contactInfoPerson + '_firstName':
        contactInfoMember = Object.assign(contactInfoMember, { firstName: value });
        break;
      case contactInfoPerson + '_lastName':
        contactInfoMember = Object.assign(contactInfoMember, { lastName: value });
        break
      case contactInfoPerson + '_phoneNumber':
        contactInfoMember = Object.assign(contactInfoMember, { phoneNumber: value });
        break
      case contactInfoPerson + '_email':
        contactInfoMember = Object.assign(contactInfoMember, { email: value });
        break
      default:
        break
    }
    const obj = {};
    obj[contactInfoPerson] = contactInfoMember;
    this.setState({ contactInfo: Object.assign({}, this.state.contactInfo, obj) }, this.updateFormValidation)
  }
  // ContactInfo


  validateCompanyInput = (company) => {
    const constraints = {
      companyName: {
        presence: {
          allowEmpty: false,
          message: function (value, attribute, validatorOptions, attributes, globalOptions) {
            return validate.format('^%{field} darf nicht leer sein', {
              field: 'Firmenname'
            });
          }
        },
      },
      industry: {
        presence: {
          allowEmpty: false,
          message: function (value, attribute, validatorOptions, attributes, globalOptions) {
            return validate.format('^%{field} darf nicht leer sein', {
              field: 'Branche'
            });
          }
        }
      },
      legalForm: {
        presence: {
          allowEmpty: false,
          message: function (value, attribute, validatorOptions, attributes, globalOptions) {
            return validate.format('^%{field} darf nicht leer sein', {
              field: 'Rechtsform'
            });
          }
        }
      },
      numberOfEmployees: {
        presence: {
          allowEmpty: false,
          message: function (value, attribute, validatorOptions, attributes, globalOptions) {
            return validate.format('^%{field} darf nicht leer sein', {
              field: 'Anzahl Mitarbeiter'
            });
          }
        }
      },

      'executiveBoard.firstName': {
        presence: {
          allowEmpty: false,
          message: function (value, attribute, validatorOptions, attributes, globalOptions) {
            return validate.format('^%{field} darf nicht leer sein', {
              field: 'Vorname Mitarbeiter'
            });
          }
        }
      },
      'executiveBoard.lastName': {
        presence: {
          allowEmpty: false,
          message: function (value, attribute, validatorOptions, attributes, globalOptions) {
            return validate.format('^%{field} darf nicht leer sein', {
              field: 'Nachname Mitarbeiter'
            });
          }
        }
      },
      'executiveBoard.phoneNumber': {
        presence: {
          allowEmpty: true,
          message: function (value, attribute, validatorOptions, attributes, globalOptions) {
            return validate.format('^%{field} darf nicht leer sein', {
              field: 'Nachname Mitarbeiter'
            });
          }
        }
      },
      'executiveBoard.email': {
        // format: {
        // email: {
        //   presence: false,
        //   email: true
        // }
        // presence: {
        //   message: function (value, attribute, validatorOptions, attributes, globalOptions) {
        //     return validate.format('^%{field} darf nicht leer sein', {
        //       field: 'This is'
        //     });
        //   }
        // },
        // }
      },
      'dataProtectionOfficer.assigned': {
        presence: {
          allowEmpty: false,
          message: function (value, attribute, validatorOptions, attributes, globalOptions) {
            return validate.format('^%{field} darf nicht leer sein', {
              field: 'Dieses feld'
            });
          }
        }
      },
      'dataProtectionOfficer.firstName': (value, attributes, attributeName, options, constraints) => {
        if (attributes.dataProtectionOfficer.assigned) {
          return {
            presence: {
              allowEmpty: false,
              message: function (value, attribute, validatorOptions, attributes, globalOptions) {
                return validate.format('^%{field} darf nicht leer sein', {
                  field: 'Vorname Mitarbeiter'
                });
              }
            }
          }
        }
      },
      'dataProtectionOfficer.lastName': (value, attributes, attributeName, options, constraints) => {
        if (attributes.dataProtectionOfficer.assigned) {
          return {
            presence: {
              allowEmpty: false,
              message: function (value, attribute, validatorOptions, attributes, globalOptions) {
                return validate.format('^%{field} darf nicht leer sein', {
                  field: 'Nachname Mitarbeiter'
                });
              }
            }
          }
        }
      },
      'informationSecurityOfficer.assigned': {
        presence: {
          allowEmpty: false,
          message: function (value, attribute, validatorOptions, attributes, globalOptions) {
            return validate.format('^%{field} darf nicht leer sein', {
              field: 'Dieses feld'
            });
          }
        }
      },
      'informationSecurityOfficer.firstName': (value, attributes, attributeName, options, constraints) => {
        if (attributes.informationSecurityOfficer.assigned) {
          return {
            presence: {
              allowEmpty: false,
              message: function (value, attribute, validatorOptions, attributes, globalOptions) {
                return validate.format('^%{field} darf nicht leer sein', {
                  field: 'Vorname Mitarbeiter'
                });
              }
            }
          }
        }
      },
      'informationSecurityOfficer.lastName': (value, attributes, attributeName, options, constraints) => {
        if (attributes.informationSecurityOfficer.assigned) {
          return {
            presence: {
              allowEmpty: false,
              message: function (value, attribute, validatorOptions, attributes, globalOptions) {
                return validate.format('^%{field} darf nicht leer sein', {
                  field: 'Nachname Mitarbeiter'
                });
              }
            }
          }
        }
      },
      'itResponsible.assigned': {
        presence: {
          allowEmpty: false,
          message: function (value, attribute, validatorOptions, attributes, globalOptions) {
            return validate.format('^%{field} darf nicht leer sein', {
              field: 'Dieses feld'
            });
          }
        }
      },
      'itResponsible.firstName': (value, attributes, attributeName, options, constraints) => {
        if (attributes.itResponsible.assigned) {
          return {
            presence: {
              allowEmpty: false,
              message: function (value, attribute, validatorOptions, attributes, globalOptions) {
                return validate.format('^%{field} darf nicht leer sein', {
                  field: 'Vorname Mitarbeiter'
                });
              }
            }
          }
        }
      },
      'itResponsible.lastName': (value, attributes, attributeName, options, constraints) => {
        if (attributes.itResponsible.assigned) {
          return {
            presence: {
              allowEmpty: false,
              message: function (value, attribute, validatorOptions, attributes, globalOptions) {
                return validate.format('^%{field} darf nicht leer sein', {
                  field: 'Nachname Mitarbeiter'
                });
              }
            }
          }
        }
      },
    };

    const externalProviderValidationMessages = company.externalITProviders.map(ep => {
      const companyNameField = ep._id + '_companyName';
      let rules = {};
      rules[companyNameField] = {
        presence: {
          allowEmpty: false,
          message: function (value, attribute, validatorOptions, attributes, globalOptions) {
            return validate.format('^%{field} darf nicht leer sein', {
              field: 'Firmenname'
            });
          }
        }
      };
      ep[companyNameField] = ep.companyName;
      return validate(ep, rules);
    }).reduce((preVal, elem) => {
      return Object.assign(preVal, elem);
    }, {});

    let validationMessages = validate(company, constraints);

    if (!validationMessages)
      validationMessages = externalProviderValidationMessages;
    if (validationMessages && externalProviderValidationMessages)
      validationMessages = Object.assign(validationMessages, externalProviderValidationMessages);

    if (validationMessages) {
      this.setState({ validationMessages: validationMessages });
    }
    else
      this.setState({ validationMessages: {} });
    return validationMessages;
  }

  handleSaveAndExit = () => {
    const company = Object.assign({},
      this.state.companyInfo,
      { externalITProviders: this.state.externalITProviders },
      this.state.contactInfo
    );


    this.setState({ loading: true });
    if (company._id) {
      updateCompany(company._id, company).then(company => {
        this.setState({ loading: false });
        this.navigateToDashboard(company._id);
      }).catch(err => console.log('Error updateCompany', err))
    } else {
      createCompany(company).then(company => {
        const moduleId = this.state.modules.find(m => m.name === 'Standard')._id; // TODO: support multiple modules
        createAssessment({ moduleId: moduleId, companyId: company._id }).then(assessment => {
          this.setState({ loading: false });
          this.navigateToDashboard(company._id);
        })
      }).catch(err => console.log('Error createCompany', err))
    }
  }

  handleSubmit = () => {
    const company = Object.assign({},
      this.state.companyInfo,
      { externalITProviders: this.state.externalITProviders },
      this.state.contactInfo
    );
    this.setState({ formSubmitting: true });
    const validationMessages = this.validateCompanyInput(company);
    if (!validationMessages || Object.keys(validationMessages).length === 0) {
      this.setState({ loading: true });
      if (company._id) {
        updateCompany(company._id, company).then(company => {
          this.setState({ loading: false });
          this.navigateToDashboard(company._id);
        }).catch(err => console.log('Error updateCompany', err))
      } else {
        createCompany(company).then(company => {
          const moduleId = this.state.modules.find(m => m.name === 'Standard')._id; // TODO: support multiple modules
          createAssessment({ moduleId: moduleId, companyId: company._id }).then(assessment => {
            this.setState({ loading: false });
            this.navigateToDashboard(company._id);
          })
        }).catch(err => console.log('Error createCompany', err))
      }
    }
    else {
      this.setState({ hasError: true }, () => {
        setTimeout(() => { this.setState({ hasError: false }); }, 3000);
      });

    }
  };

  navigateToDashboard = (companyId) => {
    setCookieCompanyId(this.props.cookies, companyId);
    this.props.history.push('/dashboard');
  }

  updateFormValidation = () => {
    const company = Object.assign({},
      this.state.companyInfo,
      { externalITProviders: this.state.externalITProviders },
      this.state.contactInfo
    );
    if (this.state.formSubmitting)
      this.validateCompanyInput(company);
  }

  render() {
    const errorPane = (
      <div className="row">
        <div className="col-12 error-pane">
          <p><Trans id="Please fill in all mandatory fields to continue." /></p>
          <img onClick={() => { this.setState({ hasError: !this.state.hasError }) }} className="close-icon" alt="" src={closeIcon} />
        </div>
      </div>
    );
    return (
      <div className="company-container">
        {
          this.state.hasError ? errorPane : ''
        }
        <div className="container">

          <div className="row">
            <div className="col-12 col-sm-11 col-md-10 col-lg-7">
              <h1><Trans id="Company Profile" /></h1>
              <p>
                <Trans id="Please provide the following information about your company. Fields marked with * are mandatory." />
              </p>
            </div>
          </div>
          <div className="row padding-middle">
            <div className="col-12 col-sm-11 col-md-10 col-lg-7">
              <CompanyInfo
                companyInfo={this.state.companyInfo}
                onSelectIndustry={this.selectIndustry}
                onSelectLegalForm={this.selectLegalForm}
                onSelectNumberOfEmployees={this.selectNumberOfEmployees}
                onInputChange={this.onCompanyInfoInputChange}
                industries={this.state.industries}
                legalForms={getLegalForms()}
                numberOfEmployees={getNumberOfEmployees()}
                validationMessages={this.state.validationMessages}
                {...this.props}
              />
            </div>
            <div className="col-12 col-md-5">
              <Explanation
                question={<Trans id="Why is this information needed?" />}
                explanation={<Trans id="This basic information about your company allows the automated compilation of the questionnaire and is displayed in the assessment report." />}
              />
            </div>
          </div>
          <div className="row padding-middle">
            <div className="col-12 col-sm-11 col-md-10 col-lg-7">
              <ExternalProviders onClickRemoveExternalProvider={this.onClickRemoveExternalProvider}
                onClickAddExternalProvider={this.onClickAddExternalProvider}
                externalITProviders={this.state.externalITProviders}
                validationMessages={this.state.validationMessages}
                onInputChange={this.onExternalProvidersInputChange}
                {...this.props}
              />
            </div>
            <div className="col-12 col-md-5">
              <Explanation
                question={<Trans id="What are external IT providers?" />}
                explanation={<Trans id="If your company's IT infrastructure is managed by external service providers, please name the corresponding contact persons. These will only be contacted after prior consultation with you." />}
              />
            </div>
          </div>
          <div className="row padding-middle">
            <div className="col-12 col-sm-11 col-md-10 col-lg-7">
              <ContactInfo
                selectContactPerson={this.selectContactPerson}

                executiveBoard={this.state.contactInfo.executiveBoard}

                dataProtectionOfficer={this.state.contactInfo.dataProtectionOfficer}
                hasDataProtectionOfficer={
                  this.state.contactInfo.dataProtectionOfficer.assigned === undefined ? '' :
                    this.state.contactInfo.dataProtectionOfficer.assigned ? 'yes' : 'no'
                }

                informationSecurityOfficer={this.state.contactInfo.informationSecurityOfficer}
                hasInformationSecurityOfficer={
                  this.state.contactInfo.informationSecurityOfficer.assigned === undefined ? '' :
                    this.state.contactInfo.informationSecurityOfficer.assigned ? 'yes' : 'no'
                }

                itResponsible={this.state.contactInfo.itResponsible}
                hasItResponsible={
                  this.state.contactInfo.itResponsible.assigned === undefined ? '' :
                    this.state.contactInfo.itResponsible.assigned ? 'yes' : 'no'
                }

                onInputChange={this.onContactInfoInputChange}
                validationMessages={this.state.validationMessages}
                {...this.props}
              />
              <div className="container-button-submit">
                <Button styleButton="company-save-exit-button" text={<Trans id="Save & Exit" />} onClick={this.handleSaveAndExit} />
                <Button styleButton="company-submit-button" text={<Trans id="Submit" />} onClick={this.handleSubmit} />
              </div>
            </div>
            <div className="col-12 col-md-5">
              <Explanation
                question={<Trans id="Why is information on contact persons needed?" />}
                explanation={<Trans id="In addition to a management contact, information on whether specific roles are assigned is relevant to the security assessment." />}
              />
            </div>
          </div>
          {
            <div className={this.state.loading ? 'loading-overlay active' : 'loading-overlay'}>
              <ReactLoading type="spin" color="#444" className="loading-icon" />
            </div>

          }
        </div>
      </div>
    );
  }
}
export default withI18n()(Company);



// WEBPACK FOOTER //
// ./src/screens/Company/Company.js